import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import 'url-search-params-polyfill';
import { getItemById, getProductCategoryIds, isMobile } from '../lib/util';

const BreadcrumbProduct = (props) => {
  const { categories, product, location } = props;
  const parsed = new URLSearchParams(location.search);
  const URLCategoryID = parsed ? parsed.get('category') : null;

  const renderCatagories = () => {
    if (categories.length > 0 && product) {
      const temp = [];

      let productCategoryId;
      if(URLCategoryID){
        productCategoryId = URLCategoryID*1;
      }else{
        const categoryIds = getProductCategoryIds(product);
        productCategoryId = categoryIds[0]*1;
      }
      temp.push(productCategoryId);

      let category = getItemById({
        id: productCategoryId,
        array: categories,
        key: 'category_ID',
      });

      while (category && category.parent_category) {
        const parentCategory = getItemById({
          id: category.parent_category.category_ID*1,
          array: categories,
          key: 'category_ID',
        });

        if(parentCategory){
          temp.push(parentCategory.category_ID*1);  
        }
        
        category = parentCategory;
      }

      return temp.reverse().map((elem, idx, arr) => {
        category = getItemById({
          id: elem,
          array: categories,
          key: 'category_ID',
        });
        return (
          <li key={`breadcrumb-${category.title}`}>
            <Link to={`/catalog/${arr.slice(0, idx + 1).join('/')}`} aria-current="page">
              {category.title}
            </Link>
          </li>
        );
      });
    }
    return [];
  };

  let productName = "";
  console.log("isMobile(): ", isMobile())
  if(product){
    if(product.chinese_title){
      productName = `${product.title} ${product.chinese_title}`;
    }else{
      productName = `${product.title}`
    }
    
  }

  return (
    <div className="breadcrumb-wrapper">
      <nav className="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <Link to="/">首頁</Link>
          </li>
          {renderCatagories()}
          {product && (
            <li className="is-active">
              <Link to={`/product/${product.product_ID}`}>{productName}</Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

BreadcrumbProduct.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  product: PropTypes.shape({
    product_ID: PropTypes.number,
    category_ID: PropTypes.number,
    name: PropTypes.string,
  }),
};

BreadcrumbProduct.defaultProps = {
  product: {
    product_ID: 1,
    category_ID: 1,
    name: 'MSA 120',
  },
};

export default BreadcrumbProduct;



// WEBPACK FOOTER //
// ./src/components/BreadcrumbProduct.js